import React from 'react';
import { ProductCardEntry } from 'helper/Home/productCardList';
import { Row } from 'react-bootstrap';
import ProductCard from './ProductCard';
import './index.scss';

export default function ProductCardList({ products }: {
  products: ProductCardEntry[],
}) {
  return (
    <Row className="product-page-row">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
        />
      ))}
    </Row>
  );
}
